module.exports = __webpack_public_path__ + "img/sass.7cca303d.png";